import { BackIcon, BrandIcon, CreatorIcon } from "Components/icons/Icons";
import ModalDecorations from "./ModalDecorations";
import ModalDialog from "../common/ModalDialog";
import ModalContent from "../common/ModalContent";
import ModalHeader from "../common/ModalHeader";
import ModalCloseButton from "../common/ModalCloseButton";
import ModalTitle from "../common/ModalTitle";
import ModalBody from "../common/ModalBody";
import ModalFooter from "../common/ModalFooter";


export default function SignUpOptionsModal({ setSignUpOptions, setModalType, setRole }) {
    return (
        <ModalDialog>
            <ModalContent>
                <ModalHeader className="tw-border-none">
                    <ModalCloseButton
                        onClose={() => {
                            setSignUpOptions(false)
                        }}
                    />
                    <ModalTitle text="Sign up as" />
                </ModalHeader>
                <ModalBody className="tw-flex-col-reverse">
                    {/* Desktop layout */}
                    <div className="signup-pop-up-row d-none d-md-flex">
                        <div className="brand-signup-col">
                            <img
                                className="brand-signup-logo"
                                src="/assets/images/brand_signup_logo.png"
                                alt="brand"
                            />
                            <div className="emptyVerticalSpace"></div>
                            <button
                                className="btn common-button-style-filled brand-sign-up-0 brand-signup-btn"
                                type="button"
                                onClick={() => {
                                    setModalType("signUpAsBrand");
                                    setSignUpOptions(false);
                                    setRole(2);
                                }}
                            >
                                Brand sign up
                            </button>
                        </div>

                        <div className="divider-column">
                            <div className="verticalLine"></div>
                            <p className="divider-text">Or</p>
                            <div className="verticalLine"></div>
                        </div>

                        <div className="creator-signup-col">
                            <div className="creator-signup-background">
                                <img
                                    className="creator-signup-logo"
                                    src="/assets/images/creator_signup_logo.png"
                                    alt="creator"
                                />
                            </div>
                            <div className="emptyVerticalSpace"></div>
                            <button
                                className="btn common-button-style-outline creator-sign-up creator-signup-btn"
                                type="button"
                                onClick={() => {
                                    setModalType("signUpAsCreator");
                                    setSignUpOptions(false);
                                    setRole(1);
                                }}
                            >
                                Creator sign up
                            </button>
                        </div>
                    </div>

                    {/* Mobile layout */}
                    {/* <div className="d-md-none text-center my-5
                    tw-flex tw-flex-col sm:tw-flex-row
                    ">
                        <button
                            className="btn common-button-style-filled brand-sign-up border-0 brand-signup-btn mb-5"
                            type="button"
                            onClick={() => {
                                setModalType("signUpAsBrand");
                                setSignUpOptions(false);
                                setRole(2);
                            }}
                        >
                            Brand sign up
                        </button>

                        <button
                            className="btn common-button-style-outline creator-sign-up creator-signup-btn"
                            type="button"
                            onClick={() => {
                                setModalType("signUpAsCreator");
                                setSignUpOptions(false);
                                setRole(1);
                            }}
                        >
                            Creator sign up
                        </button>
                    </div> */}

                    <div
                        className="
                        tw-flex sm:tw-hidden tw-relative
                        tw-box-border
                        tw-flex-col tw-justify-center tw-items-center
                        tw-px-4 tw-pt-8 tw-pb-4
                        tw-gap-3
                        tw-isolate
                        tw-bg-[rgba(255,255,255,0.4)]
                        tw-border tw-border-white
                        tw-shadow-[0px_4px_60px_rgba(120,200,202,0.05),0px_4px_40px_rgba(148,243,200,0.05)]
                        tw-backdrop-blur-[25px]
                        tw-rounded-[16px]
  "
                        type="button"
                        onClick={() => {
                            setModalType("signUpAsBrand");
                            setSignUpOptions(false);
                            setRole(2);
                        }}
                    >
                        {/* Brand login */}
                        <BrandIcon />
                        <h5 className="modal-title text-center 
                                        tw-absolute tw-bottom-4
                                        --tw-font-['Suisse_Intl'] tw-font-medium tw-text-[24px] tw-leading-[140%] tw-text-[#2C323A]
                                        tw-m-auto
                        ">Brand</h5>
                    </div>



                    <div
                        className="
                            tw-flex sm:tw-hidden tw-relative         
                            tw-box-border
                            tw-flex-col tw-justify-center tw-items-center
                            tw-px-4 tw-pt-8 tw-pb-4
                            tw-gap-3
                            tw-isolate
                            tw-bg-[rgba(255,255,255,0.4)]
                            tw-border tw-border-white
                            tw-shadow-[0px_4px_60px_rgba(120,200,202,0.05),0px_4px_40px_rgba(148,243,200,0.05)]
                            tw-backdrop-blur-[25px]
                            tw-rounded-[16px] tw-mb-5"
                        type="button"
                        onClick={() => {
                            setModalType("signUpAsCreator");
                            setSignUpOptions(false);
                            setRole(1);
                        }}
                    >
                        {/* Creator Login */}
                        <CreatorIcon />
                        <h5 className="modal-title text-center
                                    tw-absolute tw-bottom-4
                                    --tw-font-['Suisse_Intl'] tw-font-medium tw-text-[24px] tw-leading-[140%] tw-text-[#2C323A]
                                     tw-m-auto
                                    ">Creator</h5>
                    </div>

                    {/* Decoration */}
                    {/* not work correct */}
                    <ModalDecorations type="loginInAs" />
                </ModalBody>

                <ModalFooter>
                </ModalFooter>

            </ModalContent>
        </ModalDialog>
    );
}
